import React, { useState } from 'react';
import Button from '../Button';

import SMSQRcodeURL from './imgs/SMS-qrcode.png'
import Qrcode from "qrcode";

import { ReactComponent as QstMarkicon } from './imgs/question-mark.svg'
import { getQuickSmsUrl }  from '../../utils/common';
import { getStaticSmsCode } from '../../apis/Global';
import { SMSMoURL } from '../../common/constant';

const isH5 = process.env.MAIL_APP_PLATFORM === 'h5';
if (isH5) {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}

export type tipsMode = 'qrcode' | 'number';

export interface ISMSTipsBoxProps {
    tipsLabel?: string;
}

const getStaticSmsCodeHandle = async () => {
    try {
        const { data }= await getStaticSmsCode();
        const formateData = JSON.parse(data?.mo);
        return formateData?.[0] + "222";
    } catch(e) {
        return "10690163222";
    }
};

const SMSTipsBoxPc: React.FC<ISMSTipsBoxProps> = (props) => {

    const [mode, setMode] = useState<tipsMode>('qrcode');
    const [moCode, setMocode] = useState<string>("");
    const [SMSQRcode, setSMSQRcode] = useState<string>();

    const generateQrcodeUrl  = async (moCode: string) => {
        try {
            const url = `${SMSMoURL}&smsServerNumber=${moCode}`;
            Qrcode.toDataURL(url, {
                errorCorrectionLevel: 'H',
                margin: 1,
                scale: 10,
            }).then((url) => {
                setSMSQRcode(url);
            });
        } catch(e) {
            setSMSQRcode(SMSQRcodeURL);
        }
    };

    React.useEffect(() => {
        getStaticSmsCodeHandle().then(res => {
            setMocode(res);
            generateQrcodeUrl(res);
        });
    }, []);

    return (
        <>
            {mode === 'qrcode' ?
                <div className="SMS-tips-box-qrcode">
                    <h1 className="SMS-tips-box-title">
                        <span>{ props?.tipsLabel || '请使用联系手机扫描二维码，快速发送短信验证'}</span>
                        <span className="question-mark-icon-wrapper">
                            <QstMarkicon />
                            <div className="mail-sms-upward-pop" id="mail-sms-upward-pop">
                                <div className="mail-sms-upward-pop-title mail-sms-upward-pop-title1">第一步：手机扫描二维码</div>
                                <div className="mail-sms-upward-pop-desc mail-sms-upward-pop-desc1">
                                    用可扫码的APP扫描二维码，进入扫码页面<span>（建议使用手机自带浏览器打开）</span><br></br>
                                </div>
                                <div className="mail-sms-upward-pop-title mail-sms-upward-pop-title2">第二步：选择跳转到短信页面</div>
                                <div className="mail-sms-upward-pop-desc mail-sms-upward-pop-desc2">
                                    出现对话框，选择跳转到短信页面<br />
                                    <span>（部分浏览器可能不会出现对话框直接跳转）</span>
                                </div>
                                <div className="mail-sms-upward-pop-title mail-sms-upward-pop-title3">第三步：点击发送短信</div>
                                <div className="mail-sms-upward-pop-desc mail-sms-upward-pop-desc3">跳转到短信应用，系统会自动填充短信内容，点击发送短信</div>
                            </div>
                        </span>
                    </h1>
                    <img className="SMS-tips-box-img" src={SMSQRcode} alt="" />
                    <p className="SMS-tips-box-tips">扫码不成功，试试<span onClick={() => setMode('number')}>手动发送短信</span></p>
                    <p className="SMS-tips-box-tips-2">短信费用由运营商收取</p>
                </div>
                :
                <div className="SMS-tips-box-number">
                    <h1 className="SMS-tips-box-title">请发送短信进行身份验证</h1>
                    <div className="SMS-tips-box-content-wrapper">
                        <p>编辑短信  5166</p>
                        <p> 发 送 至 {moCode}</p>
                    </div>
                    <p className="SMS-tips-box-tips">打字麻烦？试试<span onClick={() => setMode('qrcode')}>扫描二维码</span>发送</p>
                    <p className="SMS-tips-box-tips-2">短信费用由运营商收取</p>
                </div>
            }
        </>
    )
}


const SMSTipsBoxH5: React.FC = () => {
    const [moCode, setMocode] = useState<string>("");

    React.useEffect(() => {
        getStaticSmsCodeHandle().then(res => {
            setMocode(res);
        });
    }, []);

    return (
            <div className="SMS-tips-box-qrcode-h5">
                <p className="SMS-tip-box-title">请发送短信进行身份验证</p>
                <p className="SMS-tip-box-subTitle">编辑短信5166 发送至 {moCode}</p>
                <a href={getQuickSmsUrl(moCode, '5166')} rel="noopener noreferrer" target="_blank">
                    <Button color="secondry" text="快速发送短信" extraClass="SMS-btn" />
                </a>
                <p className="SMS-tip-box-subTitle-tips">短信费用由运营商收取</p>
            </div>
    )
}

const SMSTipsBox = isH5 ? SMSTipsBoxH5 : SMSTipsBoxPc;

export default SMSTipsBox;
